export function formatDecimal(value) {
    let num = Number(value);
  if (isNaN(num)) {
    return value; 
  }
  return parseFloat(num?.toFixed(2).replace(/\.00$/, ''));
  }